












import { Component, Mixins, Prop } from "vue-property-decorator";
import { IContractProduct } from "@/models/contracts";
import Context from "@/mixins/context";

@Component
export default class CProdClientLabel extends Mixins(Context) {
  // Props
  @Prop({ default: null })
  public label!: IContractProduct["client_label"];
}
